import { render, staticRenderFns } from "./editMember.vue?vue&type=template&id=5b0f6f32"
import script from "./editMember.vue?vue&type=script&lang=js"
export * from "./editMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports